import { Scene, StandardMaterial, Texture, VideoTexture } from '@babylonjs/core';

export class VideoTextureMaterial extends StandardMaterial {
    public constructor(name: string, scene: Scene, textureUrl: string) {
        super(name, scene);

        let videoTexture = new VideoTexture(
            `${name}_texture`,
            textureUrl,
            scene,
            null,
            null,
            null,
            {
                autoPlay: true,
                autoUpdateTexture: true,
                loop: true
            }
        );

        videoTexture.vAng = Math.PI;

        this.emissiveTexture = videoTexture;
        this.emissiveTexture.wrapU = Texture.CLAMP_ADDRESSMODE;
        this.emissiveTexture.wrapV = Texture.CLAMP_ADDRESSMODE;
    }

    public get video(): HTMLVideoElement {
        return (this.emissiveTexture as VideoTexture).video;
    }

    public override dispose(doNotRecurse?: boolean, disposeMaterialAndTextures?: boolean): void {
        super.dispose(doNotRecurse, disposeMaterialAndTextures);

        //https://doc.babylonjs.com/features/featuresDeepDive/materials/using/videoTexture#disposal
        if (this.video && disposeMaterialAndTextures) {
            this.emissiveTexture.dispose();

            this.video.pause();

            // Remove any <source> elements, etc.
            while (this.video.firstChild) {
                this.video.removeChild(this.video.lastChild);
            }

            this.video.removeAttribute('src'); // empty source
            this.video.load();
            this.video.remove();
        }
    }
}
